import { useWidgetContext } from './WidgetProvider';
import { LauncherBubble } from './LauncherBubble';
import { FloatingPanel } from './FloatingPanel';

export function ChatWidget() {
  const { status, messages, streamingContent, isStreaming, pageContext, error, open, minimize, close, sendMessage } = useWidgetContext();

  if (status === 'open') {
    return (
      <FloatingPanel
        messages={messages}
        streamingContent={streamingContent}
        isStreaming={isStreaming}
        pageContext={pageContext}
        error={error}
        onMinimize={minimize}
        onClose={close}
        onSend={sendMessage}
      />
    );
  }

  return <LauncherBubble onClick={open} />;
}
